import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output, ViewEncapsulation } from '@angular/core';
import * as ECT from "@whoicd/icd11ect";
import { Icd10ToIcd11 } from '../../services/icd10ToIcd11.service';
export interface ISelectedEntity {
  iNo: string;
  linearizationUri: string;
  foundationUri: string;
  code: string;
  title: string;
  selectedText: string;
  searchQuery?: string;
}

@Component({
  selector: 'app-ect-angular',
  templateUrl: './ectangular-component.component.html',
  styleUrls: ['./ectangular-component.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ECTAngularComponentComponent implements OnInit {

  constructor( private _cdr: ChangeDetectorRef, private _icd10ToIcd11Service: Icd10ToIcd11)
  { }

  selected:ISelectedEntity;
    iNo = 1;

  //parent communication
  omsSelectedDiagnosis: string;
  omsSelectedDiagnosisCode: string;

  // Salidas (Outputs) para notificar cambios al padre
  @Output() diagnosisChange = new EventEmitter<string>();
  @Output() codeChange = new EventEmitter<string>();
  @Output() diagnosticSaved = new EventEmitter<void>()

browserRaised:boolean=false;
ngOnInit()
{

  // const self=this;


  // try {

  //       try
  //       {
  //           this.selected = {
  //             iNo: ' ',
  //             linearizationUri: ' ',
  //             foundationUri: ' ',
  //             code: ' ',
  //             title: ' ',
  //             selectedText: ' ',
  //             searchQuery: ' '
  //           };

  //           // Inicializa diagnosis vacíos
  //           this.omsSelectedDiagnosis = '';
  //           this.omsSelectedDiagnosisCode = '';

  //           // Configuración del ICD11 ECT
  //           const settings = {
  //           apiServerUrl: 'api',
  //           apiKey: 'e4b7c1c2-3d8a-44e7-babf-1a8f1d92af34',
  //             apiSecured:true

  //           };

  //           // Callbacks ICD
  //           const callbacks =
  //           {
  //             selectedEntityFunction: (entity: ISelectedEntity) =>
  //             {
  //               if (!entity) {
  //                 console.warn('⚠️ selectedEntityFunction recibió un valor vacío');
  //                 return;
  //               }

  //                 this.omsSelectedDiagnosis="";
  //                 this.omsSelectedDiagnosisCode="";
  //               // Guarda los valores de forma persistente en propiedades Angular
  //               this.selected = { ...entity };
  //               this.omsSelectedDiagnosis = entity.title || '';
  //               this.omsSelectedDiagnosisCode = entity.code || '';

  //               self.omsSelectedDiagnosis=entity.title;
  //               self.omsSelectedDiagnosisCode=entity.code;

  //               this._cdr.detectChanges();

  //               // 🔒 Persistencia local para mantener el valor
  //               localStorage.setItem('lastICDTitle', this.omsSelectedDiagnosis);
  //               localStorage.setItem('lastICDCode', this.omsSelectedDiagnosisCode);

  //               console.log('🧩 Guardados en localStorage:', {
  //                 title: this.omsSelectedDiagnosis,
  //                 code: this.omsSelectedDiagnosisCode
  //               });
  //             },

  //             getNewTokenFunction: async () => {
  //                 console.log('🔑 getNewTokenFunction: solicitando token...');
  //                 try {
  //                   const token  = await this._icd10ToIcd11Service.getOmsToken().toPromise();
  //                   console.log('🔑 Token obtenido OK');
  //                   return token.trim(); // <- devuelve el JWT string
  //                 } catch (err) {
  //                   console.error('❌ Error al solicitar token WHO:', err);
  //                   return null;
  //                 }
  //               },
  //               browserLoadedFunction: () => {
  //                   //this callback is called when the Browser has been fully loaded.
  //                   this.browserRaised=true;
  //                   console.log("Browser loaded!");
  //               },
  //               browserChangedFunction: (browserContent) => {
  //                   //this callback is called when the Browser has been changed.
  //                   console.log(browserContent.uri);
  //               }

  //           };

  //           // Configurar Handler global
  //           try
  //           {
  //             if (!ECT.Handler.configured){
  //               ECT.Handler.configure(settings, callbacks);
  //               ECT.Handler.bindEmbeddedBrowser("1");

  //               console.log('⚙️ ECT.Handler configurado correctamente');
  //             }

  //           } catch (error) {
  //             console.error('❌ Error al configurar ECT.Handler:', error);
  //           }
  //       }

  //       catch (error) {
  //           console.error('Error al obtener el token:', error);
  //           // Maneja el error según tus necesidades (e.g., mostrar un mensaje al usuario).
  //       }
  //   } catch (err) {
  //     console.warn('⚠️ Input no detectado en DOM dentro del timeout:', err);
  //   }



}



// private waitForSelector(selector: string, timeoutMs = 5000): Promise<void> {
//     return new Promise((resolve, reject) => {
//       const start = Date.now();
//       const check = () => {
//         if (document.querySelector(selector)) return resolve();
//         if (Date.now() - start > timeoutMs) return reject(new Error('Timeout selector ' + selector));
//         setTimeout(check, 100);
//       };
//       check();
//     });
//   }

  public reconnETC() {
    try {
      const inputs = document.querySelectorAll('.ctw-eb-window');
      inputs.forEach((el: any) => {
        try { ECT.Handler.bind(el); this._cdr.detectChanges(); } catch (e) { /* ignore per-input errors */ }

      });
      console.log('🔁 bindAllInputs ejecutado sobre', document.querySelectorAll('.ctw-eb-window').length, 'input(s)');
    } catch (err) {
      console.error('❌ bindAllInputs error', err);
    }
  }

saveDiagnostic(): void {

  // Recuperar los últimos valores persistidos (por si ECT se reinició)
  const lastTitle = localStorage.getItem('lastICDTitle') || this.selected?.title || '';
  const lastCode = localStorage.getItem('lastICDCode') || this.selected?.code || '';

  this.omsSelectedDiagnosis = lastTitle;
  this.omsSelectedDiagnosisCode = lastCode;

  console.log('🧩 Diagnóstico actual (manual):', this.omsSelectedDiagnosis);
  console.log('🧩 Código actual (manual):', this.omsSelectedDiagnosisCode);


   // Emite inmediatamente al padre
      this.diagnosisChange.emit(this.omsSelectedDiagnosis);
      this.codeChange.emit(this.omsSelectedDiagnosisCode);
      this.diagnosticSaved.emit();
 console.log('✅ Evento diagnosticSaved emitido');
  // Forzar actualización Angular
  this._cdr.detectChanges();
}


ngAfterContentInit() {
    // manual binding only after Angular has fully initialized all content
   // ECT.Handler.bind(this.iNo);
}




}
